import React from "react";

export default function Banner({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-yellow-300 dark:bg-yellow-500 w-full animate-popdown-sm md:animate-popdown flex justify-center items-center overflow-hidden md:h-12 h-24 duration-700">
      <p className="text-yellow-900 text-center p-2">{children}</p>
    </div>
  );
}
